import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Button, Typography, Collapse, CircularProgress } from '@mui/material';
import { useState, useEffect } from 'react';
import Status from './Status';
import IntervalSelector from './IntervalSelector';
import config from '../config';

function CardInput() {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState();
  const [interval, setInterval] = useState('MONTHLY');
  const [intent, setIntent] = useState();
  const [isStripeLoading, setIsStripeLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (elements) {
      const element = elements.getElement('payment');
      element.on('ready', () => {
        setIsStripeLoading(false);
      });
    }
  }, [elements]);

  const submit = async (event) => {
    // TODO probably set this to false on errors. maybe have this key off of error state instead
    // something up w this
    setIsSubmitted(true);
    event.preventDefault();
    if (!stripe || !elements) {
      setIsSubmitted(false);

      return;
    }

    // maybe wait 2 seconds and show loading indicator to make it look cooler
    try {
      const setupIntent = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: String(config.APP_URL),
          // TODO handle this return better, it *shouldnt* ever happen but its a required param
          // at this point we would still wanna post subscribe
        },
        redirect: 'if_required',
      });
      if (setupIntent) {
        setIntent(setupIntent.setupIntent);
      } else {
        // TODO make this a snackbar
        setIsSubmitted(false);

        setErrorMessage('TODO PUT BETTER ERROR HANDLING HERE');
      }
    } catch (err) {
      // TODO
      console.log(err);
      setIsSubmitted(false);
    }
  };

  return (
    <>
      {/* TODO maybe put this status in the form? */}
      {/* {intent && <Status message={statusMessage} intent={intent} interval={interval}></Status>} */}
      {/* {!intent && isSubmitted && <><Typography>Verifying card...</Typography><CircularProgress /></>} */}
      {isSubmitted && <Status intent={intent} interval={interval}></Status>}
      {!intent && (
        <form onSubmit={submit}>
          {errorMessage && <Typography>{errorMessage}</Typography>}
          {/* TODO should there be a Skeleton here instead of collapsing in this IntervalSelector? */}
          <PaymentElement />
          <Collapse in={!isStripeLoading}>
            <IntervalSelector interval={interval} setInterval={setInterval} />
            <Button visible='false' type='submit' disabled={!stripe} style={{ width: '100%' }}>
              Submit
            </Button>
          </Collapse>
        </form>
      )}
    </>
  );
}

export default CardInput;
